
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.072 16.896c.677-.825 2.013-.326 1.985.74l-.14 5.29a1.083 1.083 0 01-1.479.978l-3.242-1.276a1.083 1.083 0 01-.44-1.695zm3.852.337c-.613-.873.226-2.027 1.246-1.714l5.057 1.553c.719.22 1 1.088.547 1.687l-2.098 2.781a1.083 1.083 0 01-1.751-.03zM3.154 12.1a1.083 1.083 0 011.45-.985l4.917 1.766c1.003.36.983 1.787-.03 2.119l-5.029 1.646a1.083 1.083 0 01-1.42-1.064zm13.97-4.644a1.083 1.083 0 011.773.053l1.913 2.911a1.083 1.083 0 01-.617 1.64l-5.037 1.387c-1.028.284-1.833-.894-1.195-1.75zM9.887.047a1.285 1.285 0 011.622 1.298l.703 8.928c.014.176-.002.355-.059.522-.313.932-1.585 1.227-2.263.43a1.232 1.232 0 01-.126-.182L5.189 3.116a1.285 1.285 0 01.71-1.981z","fill":"#DC0000"}})])
          )
        }
      }
    